import { helper } from '@ember/component/helper';
import { TransferStep } from '@square/dashboard-protos/models/squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step';
function getInfoBoxStyle([style]) {
  switch (style) {
    case TransferStep.TransferConfirmation.InfoBox.Style.STYLE_INFO:
      return 'info';
    case TransferStep.TransferConfirmation.InfoBox.Style.STYLE_DO_NOT_USE:
    default:
      return 'default';
  }
}
export default helper(getInfoBoxStyle);